import { EVENTO, NS_CHAT_CLIENTE, type EstadoChat, type MensagemChat } from '@mymaxx/shared';
import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';
import { lerTokenChat } from './chat-api';

const BASE_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? '';

interface Ouvintes {
  aoReceberMensagem: (mensagem: MensagemChat) => void;
  aoMudarEstado: (estado: EstadoChat) => void;
  aoDigitar?: (nome?: string) => void;
}

/**
 * Liga o chat ao servidor enquanto a conversa está aberta. O Socket.IO reconecta sozinho;
 * quando a aba volta do sono, a tela recarrega o histórico por HTTP para não perder nada.
 */
export function useTempoRealChat(conversaId: string | null, ouvintes: Ouvintes) {
  const ref = useRef(ouvintes);
  ref.current = ouvintes;

  useEffect(() => {
    const token = lerTokenChat();
    if (!conversaId || !token) return;

    const socket: Socket = io(`${BASE_URL}${NS_CHAT_CLIENTE}`, {
      // Relido a cada tentativa: na reconexão vale o token de agora, não o da abertura.
      auth: (entregar) => entregar({ token: lerTokenChat() ?? token }),
      transports: ['websocket', 'polling'],
    });

    socket.on(EVENTO.MENSAGEM, (m: MensagemChat) => ref.current.aoReceberMensagem(m));
    socket.on(EVENTO.CONVERSA, (e: EstadoChat) => ref.current.aoMudarEstado(e));
    socket.on(EVENTO.DIGITANDO, (e: { nome?: string }) => ref.current.aoDigitar?.(e?.nome));

    return () => {
      socket.close();
    };
  }, [conversaId]);
}

/** Avisa o título da aba quando chega mensagem e o cliente está em outra janela. */
export function useAvisoNaAba(naoLidas: number) {
  useEffect(() => {
    const original = 'MyMAXX — Atendimento';
    document.title = naoLidas > 0 ? `(${naoLidas}) ${original}` : original;
    return () => {
      document.title = original;
    };
  }, [naoLidas]);
}
